import { ConfigurationResponse } from './contracts';
import axiosAPI from '../../utils/client/axiosAPI';

export class Configuration {
  public readonly id: number;
  public readonly key: string;
  public readonly label: string;
  public readonly value: string | number;
  public readonly type: string;
  public readonly settings?: any;

  constructor(data: ConfigurationResponse) {
    this.id = data.id;
    this.key = data.key;
    this.label = data.label;
    this.value = data.value;
    this.type = data.type;
    this.settings = data.settings;
  }

  static async all(): Promise<Configuration[]> {
    const { data } = await axiosAPI.get<ConfigurationResponse[]>(
      'admin/configurations'
    );
    return data.map((item) => new Configuration(item));
  }

  // You might have update, create, etc.
  static async update(payload: any) {
    // adapt as needed
    return axiosAPI.post('/admin/configurations', payload);
  }
}
